// import { Flex } from "@/common/styles";
import { Flex } from "antd";
import styled from "styled-components";

export const AddChargesContainer = styled.div`
  padding: 20px;
`;

export const ActionsHeader = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  .left,
  .right {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .left {
  }

  .right {
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: flex-end;
    margin-right: 20px;
  }
  .btn-text-back{
   color:var(--text-blue-dark) !important;
   &:hover:not(:disabled){
   background:inherit !important;
   color:var(--text-blue-dark-hover) !important;
   }
   &:disabled{
   opacity:0.6;
   }
  }
  .btn-text-continue{
   color:var(--text-accent) !important;
    &:hover:not(:disabled){
    background:inherit !important;
    color:var(--text-accent-hover) !important;
    }
    &:disabled{
   opacity:0.6;
   }
  }
`;

export const ChargesSectionContainer = styled.div`
  margin-top: 25px;
`;
